// Adjust the import path as necessary
import {
  FetchVideosResponse,
  CreateVideoResponse,
  UpdateVideoResponse,
  DeleteVideoResponse,
} from '../types/videoTypes'
import { getAdminToken } from './admin'

const API_URL = process.env.REACT_APP_API_URL

// Helper to create auth headers for FormData requests (no Content-Type)
const createFormDataAuthHeaders = (): HeadersInit => {
  const token = getAdminToken()
  const headers: HeadersInit = {}
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

export const fetchVideos = async (): Promise<FetchVideosResponse> => {
  try {
    const token = getAdminToken()
    const headers: HeadersInit = {}
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    
    const response = await fetch(`${API_URL}/video-podcasts`, { headers })

    const data = await response.json()
    if (response.ok) {
      return { success: true, videos: data.videos }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to fetch videos',
      }
    }
  } catch (error) {
    console.error('Error trying to fetch videos', error)
    return {
      success: false,
      message: 'An error occurred during fetching videos',
    }
  }
}

export const createVideo = async (
  videoData: FormData
): Promise<CreateVideoResponse> => {
  try {
    const response = await fetch(`${API_URL}/video-podcasts`, {
      method: 'POST',
      headers: createFormDataAuthHeaders(),
      body: videoData,
    })
    const data = await response.json()
    if (response.ok) {
      return { success: true, video: data.createdVideo }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to create video',
      }
    }
  } catch (error) {
    console.error('Error trying to create a video', error)
    return {
      success: false,
      message: 'An error occurred during video creation',
    }
  }
}

export const updateVideo = async (
  videoId: string,
  videoData: FormData
): Promise<UpdateVideoResponse> => {
  try {
    const response = await fetch(`${API_URL}/video-podcasts/${videoId}`, {
      method: 'PUT',
      headers: createFormDataAuthHeaders(),
      body: videoData,
    })
    const data = await response.json()
    if (response.ok) {
      return { success: true, video: data.updatedVideo }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to update video',
      }
    }
  } catch (error) {
    console.error('Error trying to update a video', error)
    return {
      success: false,
      message: 'An error occurred during video update',
    }
  }
}

export const deleteVideo = async (
  videoId: string
): Promise<DeleteVideoResponse> => {
  try {
    const token = getAdminToken()
    const headers: HeadersInit = {}
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
    
    const response = await fetch(`${API_URL}/video-podcasts/${videoId}`, {
      method: 'DELETE',
      headers,
    })
    if (response.ok) {
      const data = await response.json()
      return {
        success: true,
        message: data.message || 'Video deleted successfully',
      }
    } else {
      const errorData = await response.json()
      return {
        success: false,
        message: errorData.message || 'Failed to delete video',
      }
    }
  } catch (error) {
    console.error('Error trying to delete a video', error)
    return {
      success: false,
      message: 'An error occurred during video deletion',
    }
  }
}
